import Quote from "./Form";
import useYourQuote from "./hooks/useYourQuote";

export const QuotePage = () => {
  const props = useYourQuote();
  return <Quote {...props} />;
};

export default QuotePage;
